import { render, staticRenderFns } from "./scrolldown-tail.vue?vue&type=template&id=78366c76&scoped=true&"
import script from "./scrolldown-tail.vue?vue&type=script&lang=js&"
export * from "./scrolldown-tail.vue?vue&type=script&lang=js&"
import style0 from "./scrolldown-tail.vue?vue&type=style&index=0&id=78366c76&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78366c76",
  null
  
)

export default component.exports